// Extended platform data for multi-role telemedicine system
// Adds: Pharmacies, Diagnostic Rooms, Device Models/Kits, Accredited Structures,
//       Operators, Managers, Bookings, Campaigns, Consumables, Slot availability

import { servicesData, serviceBundlesData } from "@/data/mockData";

// ============ PHARMACIES (anagrafica) ============
export const pharmaciesData = [
  {
    id: "ph1",
    name: "Farmacia Centrale Milano",
    region: "Lombardia",
    province: "MI",
    address: "Via Roma 10, Milano",
    phone: "+39 02 1234567",
    email: "info@farmaciacentrale.it",
    fiscalCode: "12345678901",
    vatNumber: "IT12345678901",
    managerId: "mgr1",
    diagnosticRoomIds: ["dr1", "dr2"],
    accreditedStructureIds: ["str1", "str2"],
    associatedSpecialists: ["doc1", "doc2"],
    openingHours: { mon: "08:00-19:30", tue: "08:00-19:30", wed: "08:00-19:30", thu: "08:00-19:30", fri: "08:00-19:30", sat: "09:00-13:00", sun: "Chiuso" }
  },
  {
    id: "ph2",
    name: "Farmacia San Donato",
    region: "Lombardia",
    province: "MI",
    address: "Via Manzoni 5, San Donato Milanese",
    phone: "+39 02 7654321",
    email: "info@farmaciasandonato.it",
    fiscalCode: "23456789012",
    vatNumber: "IT23456789012",
    managerId: "mgr2",
    diagnosticRoomIds: ["dr3"],
    accreditedStructureIds: ["str1"],
    associatedSpecialists: ["doc1"],
    openingHours: { mon: "08:30-20:00", tue: "08:30-20:00", wed: "08:30-20:00", thu: "08:30-20:00", fri: "08:30-20:00", sat: "09:00-13:00", sun: "Chiuso" }
  },
  {
    id: "ph3",
    name: "Farmacia del Duomo Bergamo",
    region: "Lombardia",
    province: "BG",
    address: "Piazza Vecchia 3, Bergamo",
    phone: "+39 035 123456",
    email: "info@farmaciaduomo.it",
    fiscalCode: "34567890123",
    vatNumber: "IT34567890123",
    managerId: "mgr1",
    diagnosticRoomIds: ["dr4"],
    accreditedStructureIds: ["str2"],
    associatedSpecialists: ["doc2"],
    openingHours: { mon: "08:00-19:00", tue: "08:00-19:00", wed: "08:00-19:00", thu: "08:00-19:00", fri: "08:00-19:00", sat: "09:00-13:00", sun: "Chiuso" }
  }
];

// ============ DIAGNOSTIC ROOMS (sale diagnostiche) ============
export const diagnosticRoomsData = [
  { id: "dr1", name: "Sala Diagnostica A", pharmacyId: "ph1", kitId: "kit1", capabilities: ["ecg", "ossimetria", "pressione", "spirometria", "glicemia", "emoglobina_glicata", "peso", "temperatura"] },
  { id: "dr2", name: "Sala Analisi B", pharmacyId: "ph1", kitId: "kit2", capabilities: ["emocromo", "colesterolo", "trigliceridi", "emoglobina_glicata", "glicemia", "pressione", "peso", "temperatura"] },
  { id: "dr3", name: "Sala Polifunzionale", pharmacyId: "ph2", kitId: "kit3", capabilities: ["ecg", "pressione", "ossimetria", "glicemia", "colesterolo", "peso", "temperatura", "emoglobina_glicata"] },
  { id: "dr4", name: "Sala Cardiologica", pharmacyId: "ph3", kitId: "kit1", capabilities: ["ecg", "pressione", "ossimetria", "spirometria", "peso", "temperatura"] }
];

// ============ MEDICAL DEVICE MODELS (modelli elettromedicali) ============
export const medicalDeviceModelsData = [
  { id: "dm1", name: "Cardioline ECG-2000", brand: "Cardioline", type: "ECG", profile: "ecg", certification: "MDR Classe IIa" },
  { id: "dm2", name: "MIR Spirobank II", brand: "MIR", type: "Spirometro", profile: "spirometria", certification: "MDR Classe IIa" },
  { id: "dm3", name: "Beurer PO80", brand: "Beurer", type: "Saturimetro", profile: "ossimetria", certification: "MDR Classe IIa" },
  { id: "dm4", name: "Omron M7 Intelli IT", brand: "Omron", type: "Sfigmomanometro", profile: "pressione", certification: "MDR Classe IIa" },
  { id: "dm5", name: "Roche Accu-Chek Inform II", brand: "Roche", type: "Glucometro", profile: "glicemia", certification: "MDR Classe IIa" },
  { id: "dm6", name: "Mindray BC-3600", brand: "Mindray", type: "Analizzatore Ematologico", profile: "emocromo", certification: "MDR Classe IIa" },
  { id: "dm7", name: "CardioCheck PA", brand: "PTS Diagnostics", type: "Analizzatore Lipidico", profile: "colesterolo", certification: "MDR Classe IIa" }
];

// ============ MEDICAL DEVICE KITS ============
export const medicalDeviceKitsData = [
  { id: "kit1", name: "Kit Cardio-Respiratorio", deviceModelIds: ["dm1", "dm2", "dm3", "dm4"], description: "ECG + Spirometria + Saturimetro + Sfigmo" },
  { id: "kit2", name: "Kit Analisi Ematochimiche", deviceModelIds: ["dm5", "dm6", "dm7"], description: "Glucometro + Emocromo + Lipidi" },
  { id: "kit3", name: "Kit Cardio Base", deviceModelIds: ["dm1", "dm3", "dm4", "dm5", "dm7"], description: "ECG + Saturimetro + PA + Glicemia + Colesterolo" }
];

// ============ ACCREDITED STRUCTURES (strutture accreditate) ============
export const accreditedStructuresData = [
  {
    id: "str1",
    name: "Centro Diagnostico Lombardia",
    region: "Lombardia",
    province: "MI",
    address: "Via Vittor Pisani 12, Milano",
    phone: "+39 02 99887766",
    email: "refertazione@cdlombardia.it",
    fiscalCode: "98765432109",
    vatNumber: "IT98765432109",
    managerId: "smgr1",
    specialistIds: ["doc1", "doc2"],
    handledServices: ["ecg", "spirometria", "emocromo", "colesterolo", "emoglobina_glicata"],
    associatedPharmacies: ["ph1", "ph2"]
  },
  {
    id: "str2",
    name: "Poliambulatorio Bergamo Salute",
    region: "Lombardia",
    province: "BG",
    address: "Via XX Settembre 50, Bergamo",
    phone: "+39 035 998877",
    email: "referti@bergamosalute.it",
    fiscalCode: "87654321098",
    vatNumber: "IT87654321098",
    managerId: "smgr2",
    specialistIds: ["doc2"],
    handledServices: ["ecg", "visus", "spirometria", "colesterolo"],
    associatedPharmacies: ["ph1", "ph3"]
  }
];

// ============ SPECIALIST <-> STRUCTURE ASSIGNMENTS ============
export const specialistAssignmentsData = [
  { specialistId: "doc1", structureId: "str1", services: ["ecg", "emocromo", "colesterolo", "emoglobina_glicata"] },
  { specialistId: "doc2", structureId: "str1", services: ["ecg", "spirometria"] },
  { specialistId: "doc2", structureId: "str2", services: ["ecg", "visus", "spirometria", "colesterolo"] }
];

// ============ OPERATORS (operatori farmacia) ============
export const operatorsData = [
  { id: "op1", name: "Dr. Mario Rossi", email: "mario.rossi@farmacia.it", phone: "+39 333 1112233", pharmacyIds: ["ph1"], role: "operator" },
  { id: "op2", name: "Dr.ssa Anna Conti", email: "anna.conti@farmacia.it", phone: "+39 333 4445566", pharmacyIds: ["ph1", "ph2"], role: "operator" },
  { id: "op3", name: "Dr. Paolo Greco", email: "paolo.greco@farmacia.it", phone: "+39 333 7778899", pharmacyIds: ["ph3"], role: "operator" }
];

// ============ MANAGERS (responsabili farmacia / struttura) ============
export const managersData = [
  { id: "mgr1", name: "Dr.ssa Carla Moretti", email: "c.moretti@witapp.it", phone: "+39 02 1112223", pharmacyIds: ["ph1", "ph3"], role: "pharmacy_manager" },
  { id: "mgr2", name: "Dr. Luigi Marini", email: "l.marini@witapp.it", phone: "+39 02 4445556", pharmacyIds: ["ph2"], role: "pharmacy_manager" },
  { id: "smgr1", name: "Dr. Roberto Galli", email: "r.galli@cdlombardia.it", phone: "+39 02 7778889", structureIds: ["str1"], role: "structure_manager" },
  { id: "smgr2", name: "Dr.ssa Elisa Fontana", email: "e.fontana@bergamosalute.it", phone: "+39 035 1234567", structureIds: ["str2"], role: "structure_manager" }
];

// ============ SERVICE CATALOG (extends with pricing, structure assignment) ============
export const serviceCatalogData = servicesData.map(s => ({
  ...s,
  price: { ecg: 35, spirometria: 45, emocromo: 25, glicemia: 8, colesterolo: 15, trigliceridi: 12, pressione: 5, ossimetria: 5, temperatura: 3, peso: 5, visus: 20, emoglobina_glicata: 18 }[s.id] || 10,
  structureIds: s.requiresReport
    ? accreditedStructuresData.filter(str => str.handledServices.includes(s.id)).map(str => str.id)
    : []
}));

// ============ URGENCY LEVELS ============
export const urgencyLevels = [
  { id: "urgent", label: "Urgente", description: "Entro 24 ore", color: "destructive", maxDays: 1 },
  { id: "deferrable", label: "Differibile", description: "Entro 7 giorni", color: "warning", maxDays: 7 },
  { id: "scheduled", label: "Programmata", description: "Entro 30 giorni", color: "default", maxDays: 30 }
];

// ============ BOOKINGS (prenotazioni complete) ============
export const bookingsData = [
  {
    id: "bk1",
    patientId: "1",
    pharmacyId: "ph1",
    diagnosticRoomId: "dr1",
    serviceIds: ["ecg", "pressione"],
    bundleId: null,
    urgency: "deferrable",
    date: "2026-01-29",
    time: "10:00",
    duration: 20,
    status: "confirmed",
    structureId: "str1",
    specialistId: "doc1",
    bookedBy: "op1",
    bookedByRole: "operator",
    createdAt: "2026-01-25T14:30:00",
    notes: ""
  },
  {
    id: "bk2",
    patientId: "2",
    pharmacyId: "ph1",
    diagnosticRoomId: "dr2",
    serviceIds: [],
    bundleId: "diabetes",
    urgency: "scheduled",
    date: "2026-02-03",
    time: "09:30",
    duration: 25,
    status: "confirmed",
    structureId: "str1",
    specialistId: "doc1",
    bookedBy: "2",
    bookedByRole: "citizen",
    createdAt: "2026-01-26T18:00:00",
    notes: "Controllo periodico"
  },
  {
    id: "bk3",
    patientId: "1",
    pharmacyId: "ph1",
    diagnosticRoomId: "dr1",
    serviceIds: ["ecg", "colesterolo"],
    bundleId: null,
    urgency: "scheduled",
    date: "2026-02-12",
    time: "11:00",
    duration: 25,
    status: "confirmed",
    structureId: "str1",
    specialistId: "doc1",
    bookedBy: "1",
    bookedByRole: "citizen",
    createdAt: "2026-02-01T09:00:00",
    notes: "Controllo periodico cardiologico"
  },
  {
    id: "bk4",
    patientId: "1",
    pharmacyId: "ph2",
    diagnosticRoomId: "dr3",
    serviceIds: ["glicemia", "pressione"],
    bundleId: null,
    urgency: "deferrable",
    date: "2026-02-08",
    time: "16:30",
    duration: 10,
    status: "pending",
    structureId: null,
    specialistId: null,
    bookedBy: "op2",
    bookedByRole: "operator",
    createdAt: "2026-02-04T15:00:00",
    notes: ""
  }
];

// ============ CAMPAIGNS ============
export const campaignsData = [
  { id: "camp1", name: "Mese del Cuore", services: ["ecg", "pressione", "colesterolo"], discount: 20, period: { start: "2026-02-01", end: "2026-02-28" }, pharmacyIds: ["ph1", "ph2", "ph3"], status: "scheduled" },
  { id: "camp2", name: "Prevenzione Diabete", services: ["glicemia", "emoglobina_glicata"], bundleId: "diabetes", discount: 15, period: { start: "2026-01-15", end: "2026-03-15" }, pharmacyIds: ["ph1", "ph3"], status: "active" },
  { id: "camp3", name: "Check Respiratorio", services: ["spirometria", "ossimetria"], discount: 10, period: { start: "2026-03-01", end: "2026-04-30" }, pharmacyIds: ["ph1", "ph2"], status: "draft" }
];

// ============ CONSUMABLES STOCK ============
export const consumablesData = [
  { id: "cons1", name: "Elettrodi ECG (conf. 50)", pharmacyId: "ph1", stock: 234, threshold: 100, unit: "pz", lastRestock: "2026-01-15" },
  { id: "cons2", name: "Boccagli Spirometria", pharmacyId: "ph1", stock: 78, threshold: 100, unit: "pz", lastRestock: "2026-01-10" },
  { id: "cons3", name: "Strisce Glucometro", pharmacyId: "ph1", stock: 540, threshold: 200, unit: "pz", lastRestock: "2026-01-20" },
  { id: "cons4", name: "Reagenti Colesterolo", pharmacyId: "ph1", stock: 45, threshold: 50, unit: "kit", lastRestock: "2026-01-12" },
  { id: "cons5", name: "Elettrodi ECG (conf. 50)", pharmacyId: "ph2", stock: 112, threshold: 100, unit: "pz", lastRestock: "2026-01-18" },
  { id: "cons6", name: "Strisce Emocromo", pharmacyId: "ph1", stock: 156, threshold: 80, unit: "pz", lastRestock: "2026-01-22" }
];

// ============ ROLES METADATA ============
export const platformRoles = [
  {
    id: "operator",
    name: "Operatore di Farmacia",
    description: "Esegue prestazioni, prenota, identifica pazienti via Tessera Sanitaria",
    icon: "Stethoscope",
    color: "from-sky-500 to-blue-600",
    accent: "sky",
    targetPath: "/patients",
    mdrCategory: "mixed"
  },
  {
    id: "pharmacy_manager",
    name: "Responsabile di Farmacia",
    description: "Pianifica sale diagnostiche, monitora KPI, configura prestazioni",
    icon: "Building2",
    color: "from-indigo-500 to-violet-600",
    accent: "indigo",
    targetPath: "/manager",
    mdrCategory: "admin"
  },
  {
    id: "citizen",
    name: "Cittadino",
    description: "Prenota prestazioni, consulta referti, gestisce consensi e FSE",
    icon: "User",
    color: "from-emerald-500 to-teal-600",
    accent: "emerald",
    targetPath: "/patient",
    mdrCategory: "admin"
  },
  {
    id: "specialist",
    name: "Medico Specialista",
    description: "Reperta esami strumentali, firma digitalmente, prenota approfondimenti",
    icon: "ClipboardList",
    color: "from-fuchsia-500 to-purple-600",
    accent: "fuchsia",
    targetPath: "/doctor",
    mdrCategory: "medical"
  },
  {
    id: "structure_manager",
    name: "Responsabile Struttura Accreditata",
    description: "Configura medici, monitora attività, rendiconta servizi",
    icon: "Hospital",
    color: "from-cyan-500 to-teal-600",
    accent: "cyan",
    targetPath: "/structure",
    mdrCategory: "admin"
  },
  {
    id: "admin",
    name: "Amministratore di Sistema",
    description: "Gestisce farmacie, strutture, kit elettromedicali e responsabili",
    icon: "Settings",
    color: "from-slate-500 to-zinc-700",
    accent: "slate",
    targetPath: "/admin",
    mdrCategory: "admin"
  }
];

// ============ SLOT AVAILABILITY GENERATOR ============
const seedRandom = (seed) => {
  let s = seed;
  return () => {
    s = (s * 9301 + 49297) % 233280;
    return s / 233280;
  };
};

/**
 * Generate available slots for a diagnostic room on a given date for the requested services.
 * Mocked deterministic generator (per room+date) so behavior is stable across renders.
 */
export const getAvailableSlots = (roomId, dateISO, serviceDuration = 15) => {
  const room = diagnosticRoomsData.find(r => r.id === roomId);
  if (!room) return [];

  // Skip Sundays
  const d = new Date(dateISO);
  if (d.getDay() === 0) return [];

  const seed = roomId.charCodeAt(2) + d.getDate() * 31 + d.getMonth() * 7;
  const rnd = seedRandom(seed);

  const slots = [];
  const startHour = 9;
  const endHour = d.getDay() === 6 ? 13 : 18; // Saturday short hours
  for (let h = startHour; h < endHour; h++) {
    for (let m = 0; m < 60; m += 30) {
      const isBusy = rnd() < 0.35; // ~35% slot busy
      slots.push({
        time: `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`,
        available: !isBusy,
        duration: serviceDuration
      });
    }
  }
  return slots;
};

/**
 * Determine which diagnostic rooms in a pharmacy can perform a set of services
 */
export const getEligibleRooms = (pharmacyId, serviceIds) => {
  return diagnosticRoomsData
    .filter(r => r.pharmacyId === pharmacyId)
    .filter(r => serviceIds.every(sid => r.capabilities.includes(sid)));
};

/**
 * Determine which accredited structures can handle a service set
 */
export const getEligibleStructures = (pharmacyId, serviceIds) => {
  const pharmacy = pharmaciesData.find(p => p.id === pharmacyId);
  if (!pharmacy) return [];
  const reportingServices = serviceIds.filter(sid => {
    const s = servicesData.find(x => x.id === sid);
    return s?.requiresReport;
  });
  if (reportingServices.length === 0) return [];
  return accreditedStructuresData
    .filter(str => pharmacy.accreditedStructureIds.includes(str.id))
    .filter(str => reportingServices.every(sid => str.handledServices.includes(sid)));
};

// ============ HELPERS ============
export const getPharmacyById = (id) => pharmaciesData.find(p => p.id === id);
export const getRoomById = (id) => diagnosticRoomsData.find(r => r.id === id);
export const getStructureById = (id) => accreditedStructuresData.find(s => s.id === id);
export const getKitById = (id) => medicalDeviceKitsData.find(k => k.id === id);
export const getDeviceModelById = (id) => medicalDeviceModelsData.find(d => d.id === id);
export const getOperatorById = (id) => operatorsData.find(o => o.id === id);
export const getManagerById = (id) => managersData.find(m => m.id === id);

export const getServicesForBundle = (bundleId) => {
  const bundle = serviceBundlesData.find(b => b.id === bundleId);
  if (!bundle) return [];
  return bundle.services.map(sid => servicesData.find(s => s.id === sid)).filter(Boolean);
};

export const getBookingsByPharmacy = (phId) => bookingsData.filter(b => b.pharmacyId === phId);
export const getBookingsByPatient = (pid) => bookingsData.filter(b => b.patientId === pid);
export const getBookingsByStructure = (strId) => bookingsData.filter(b => b.structureId === strId);

export const totalServicePrice = (serviceIds) => {
  return serviceIds.reduce((acc, sid) => {
    const s = serviceCatalogData.find(x => x.id === sid);
    return acc + (s?.price || 0);
  }, 0);
};

// ============ ROOM WEEKLY SCHEDULES (apertura sale) ============
// Each entry: { roomId, weekday (0..6, 0=Sun), open, slots: [{ start, end }] }
export const roomSchedulesData = [
  { roomId: "dr1", weekday: 1, open: true, slots: [{ start: "09:00", end: "13:00" }, { start: "14:30", end: "18:30" }] },
  { roomId: "dr1", weekday: 2, open: true, slots: [{ start: "09:00", end: "13:00" }, { start: "14:30", end: "18:30" }] },
  { roomId: "dr1", weekday: 3, open: true, slots: [{ start: "09:00", end: "13:00" }, { start: "14:30", end: "18:30" }] },
  { roomId: "dr1", weekday: 4, open: true, slots: [{ start: "09:00", end: "13:00" }, { start: "14:30", end: "18:30" }] },
  { roomId: "dr1", weekday: 5, open: true, slots: [{ start: "09:00", end: "13:00" }, { start: "14:30", end: "18:30" }] },
  { roomId: "dr1", weekday: 6, open: true, slots: [{ start: "09:00", end: "12:30" }] },
  { roomId: "dr1", weekday: 0, open: false, slots: [] },
  { roomId: "dr2", weekday: 1, open: true, slots: [{ start: "09:00", end: "13:00" }] },
  { roomId: "dr2", weekday: 2, open: true, slots: [{ start: "09:00", end: "13:00" }, { start: "15:00", end: "18:00" }] },
  { roomId: "dr2", weekday: 3, open: true, slots: [{ start: "09:00", end: "13:00" }] },
  { roomId: "dr2", weekday: 4, open: true, slots: [{ start: "09:00", end: "13:00" }, { start: "15:00", end: "18:00" }] },
  { roomId: "dr2", weekday: 5, open: true, slots: [{ start: "09:00", end: "13:00" }] },
  { roomId: "dr2", weekday: 6, open: false, slots: [] },
  { roomId: "dr2", weekday: 0, open: false, slots: [] },
  { roomId: "dr3", weekday: 1, open: true, slots: [{ start: "08:30", end: "13:00" }, { start: "15:00", end: "19:30" }] },
  { roomId: "dr3", weekday: 2, open: true, slots: [{ start: "08:30", end: "13:00" }, { start: "15:00", end: "19:30" }] },
  { roomId: "dr3", weekday: 3, open: true, slots: [{ start: "08:30", end: "13:00" }, { start: "15:00", end: "19:30" }] },
  { roomId: "dr3", weekday: 4, open: true, slots: [{ start: "08:30", end: "13:00" }, { start: "15:00", end: "19:30" }] },
  { roomId: "dr3", weekday: 5, open: true, slots: [{ start: "08:30", end: "13:00" }, { start: "15:00", end: "19:30" }] },
  { roomId: "dr3", weekday: 6, open: true, slots: [{ start: "09:00", end: "12:30" }] },
  { roomId: "dr3", weekday: 0, open: false, slots: [] },
  { roomId: "dr4", weekday: 1, open: true, slots: [{ start: "08:00", end: "13:00" }, { start: "14:30", end: "18:00" }] },
  { roomId: "dr4", weekday: 2, open: true, slots: [{ start: "08:00", end: "13:00" }] },
  { roomId: "dr4", weekday: 3, open: true, slots: [{ start: "08:00", end: "13:00" }, { start: "14:30", end: "18:00" }] },
  { roomId: "dr4", weekday: 4, open: true, slots: [{ start: "08:00", end: "13:00" }] },
  { roomId: "dr4", weekday: 5, open: true, slots: [{ start: "08:00", end: "13:00" }, { start: "14:30", end: "18:00" }] },
  { roomId: "dr4", weekday: 6, open: false, slots: [] },
  { roomId: "dr4", weekday: 0, open: false, slots: [] }
];

export const weekdayLabels = ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"];

// ============ SERVICE EXECUTION TIMES (per pharmacy override) ============
export const serviceExecutionTimesData = [
  { pharmacyId: "ph1", serviceId: "ecg", duration: 10, bufferBefore: 2, bufferAfter: 3 },
  { pharmacyId: "ph1", serviceId: "spirometria", duration: 15, bufferBefore: 2, bufferAfter: 3 },
  { pharmacyId: "ph1", serviceId: "emocromo", duration: 8, bufferBefore: 1, bufferAfter: 2 },
  { pharmacyId: "ph1", serviceId: "colesterolo", duration: 6, bufferBefore: 1, bufferAfter: 1 },
  { pharmacyId: "ph1", serviceId: "glicemia", duration: 4, bufferBefore: 0, bufferAfter: 1 },
  { pharmacyId: "ph1", serviceId: "pressione", duration: 4, bufferBefore: 0, bufferAfter: 1 },
  { pharmacyId: "ph1", serviceId: "ossimetria", duration: 3, bufferBefore: 0, bufferAfter: 1 },
  { pharmacyId: "ph1", serviceId: "emoglobina_glicata", duration: 6, bufferBefore: 1, bufferAfter: 1 },
  { pharmacyId: "ph1", serviceId: "trigliceridi", duration: 6, bufferBefore: 1, bufferAfter: 1 },
  { pharmacyId: "ph1", serviceId: "peso", duration: 3, bufferBefore: 0, bufferAfter: 0 },
  { pharmacyId: "ph1", serviceId: "temperatura", duration: 2, bufferBefore: 0, bufferAfter: 0 }
];

// ============ AGE-BUCKET STATS PER PHARMACY (mock for monitoring) ============
export const monitoringByAgeData = [
  { pharmacyId: "ph1", range: "18-30", count: 32, percentage: 12 },
  { pharmacyId: "ph1", range: "31-45", count: 78, percentage: 28 },
  { pharmacyId: "ph1", range: "46-60", count: 92, percentage: 33 },
  { pharmacyId: "ph1", range: "61-75", count: 56, percentage: 20 },
  { pharmacyId: "ph1", range: "75+", count: 21, percentage: 7 }
];

// ============ DEVICE USAGE STATS PER PHARMACY ============
export const deviceUsageData = [
  { pharmacyId: "ph1", deviceModelId: "dm1", uses: 89, lastUse: "2026-02-04", uptime: 99.2 },
  { pharmacyId: "ph1", deviceModelId: "dm2", uses: 45, lastUse: "2026-02-03", uptime: 98.5 },
  { pharmacyId: "ph1", deviceModelId: "dm3", uses: 198, lastUse: "2026-02-05", uptime: 99.9 },
  { pharmacyId: "ph1", deviceModelId: "dm4", uses: 312, lastUse: "2026-02-05", uptime: 99.7 },
  { pharmacyId: "ph1", deviceModelId: "dm5", uses: 245, lastUse: "2026-02-05", uptime: 99.8 },
  { pharmacyId: "ph1", deviceModelId: "dm6", uses: 156, lastUse: "2026-02-04", uptime: 97.3 },
  { pharmacyId: "ph1", deviceModelId: "dm7", uses: 134, lastUse: "2026-02-04", uptime: 98.9 }
];

// ============ MONTHLY PERFORMANCE PER PHARMACY ============
export const pharmacyMonthlyPerformance = [
  { pharmacyId: "ph1", month: "Set", prestazioni: 178, pazienti: 102, fatturato: 4250 },
  { pharmacyId: "ph1", month: "Ott", prestazioni: 203, pazienti: 115, fatturato: 4980 },
  { pharmacyId: "ph1", month: "Nov", prestazioni: 189, pazienti: 108, fatturato: 4520 },
  { pharmacyId: "ph1", month: "Dic", prestazioni: 156, pazienti: 94, fatturato: 3800 },
  { pharmacyId: "ph1", month: "Gen", prestazioni: 167, pazienti: 98, fatturato: 4100 },
  { pharmacyId: "ph1", month: "Feb", prestazioni: 142, pazienti: 87, fatturato: 3450 }
];

export const getRoomScheduleByWeekday = (roomId, weekday) =>
  roomSchedulesData.find(s => s.roomId === roomId && s.weekday === weekday);

export const getServiceExecTime = (pharmacyId, serviceId) =>
  serviceExecutionTimesData.find(s => s.pharmacyId === pharmacyId && s.serviceId === serviceId);

// ============ STRUCTURE REFERTAZIONI MONITORING ============
// SLA mock per servizio refertabile (in ore)
export const reportingSLA = {
  ecg: 24,
  spirometria: 48,
  emocromo: 24,
  colesterolo: 48,
  emoglobina_glicata: 48,
  visus: 72
};

// Refertazioni con time-to-report tracking
export const reportingActivityData = [
  { id: "ra1", structureId: "str1", reportId: "rep1", specialistId: "doc1", serviceId: "emocromo", patientId: "1", pharmacyId: "ph1", receivedAt: "2026-02-04T09:30:00", deliveredAt: null, status: "pending", urgency: "normal" },
  { id: "ra2", structureId: "str1", reportId: "rep2", specialistId: "doc1", serviceId: "ecg", patientId: "2", pharmacyId: "ph1", receivedAt: "2026-02-04T10:15:00", deliveredAt: null, status: "pending", urgency: "urgent" },
  { id: "ra3", structureId: "str1", reportId: "rep5", specialistId: "doc2", serviceId: "emocromo", patientId: "5", pharmacyId: "ph2", receivedAt: "2026-02-03T09:00:00", deliveredAt: null, status: "in_review", urgency: "normal" },
  { id: "ra4", structureId: "str1", reportId: "rep6", specialistId: "doc1", serviceId: "ecg", patientId: "6", pharmacyId: "ph1", receivedAt: "2026-02-02T10:00:00", deliveredAt: "2026-02-02T15:30:00", status: "signed", urgency: "normal" },
  { id: "ra5", structureId: "str1", reportId: "rep7", specialistId: "doc2", serviceId: "emoglobina_glicata", patientId: "7", pharmacyId: "ph2", receivedAt: "2026-02-02T11:30:00", deliveredAt: "2026-02-02T16:00:00", status: "signed", urgency: "urgent" },
  { id: "ra6", structureId: "str1", reportId: "rep8", specialistId: "doc1", serviceId: "emocromo", patientId: "8", pharmacyId: "ph1", receivedAt: "2026-02-01T09:00:00", deliveredAt: "2026-02-01T14:00:00", status: "signed", urgency: "normal" },
  { id: "ra7", structureId: "str1", reportId: "rep-ext1", specialistId: "doc2", serviceId: "ecg", patientId: "3", pharmacyId: "ph1", receivedAt: "2026-01-30T15:00:00", deliveredAt: "2026-01-31T09:00:00", status: "signed", urgency: "normal" },
  { id: "ra8", structureId: "str1", reportId: "rep-ext2", specialistId: "doc1", serviceId: "colesterolo", patientId: "4", pharmacyId: "ph2", receivedAt: "2026-01-29T11:00:00", deliveredAt: "2026-01-29T18:00:00", status: "signed", urgency: "normal" }
];

// ============ STRUCTURE BILLING DATA ============
export const structureBillingData = [
  { id: "bil1", structureId: "str1", month: "2026-01", pharmacyId: "ph1", specialistId: "doc1", serviceId: "ecg", count: 24, unitFee: 18, total: 432 },
  { id: "bil2", structureId: "str1", month: "2026-01", pharmacyId: "ph1", specialistId: "doc1", serviceId: "emocromo", count: 18, unitFee: 12, total: 216 },
  { id: "bil3", structureId: "str1", month: "2026-01", pharmacyId: "ph1", specialistId: "doc2", serviceId: "spirometria", count: 9, unitFee: 22, total: 198 },
  { id: "bil4", structureId: "str1", month: "2026-01", pharmacyId: "ph2", specialistId: "doc1", serviceId: "emocromo", count: 12, unitFee: 12, total: 144 },
  { id: "bil5", structureId: "str1", month: "2026-01", pharmacyId: "ph2", specialistId: "doc1", serviceId: "colesterolo", count: 15, unitFee: 9, total: 135 },
  { id: "bil6", structureId: "str1", month: "2026-01", pharmacyId: "ph2", specialistId: "doc2", serviceId: "ecg", count: 8, unitFee: 18, total: 144 },
  { id: "bil7", structureId: "str1", month: "2026-02", pharmacyId: "ph1", specialistId: "doc1", serviceId: "ecg", count: 8, unitFee: 18, total: 144 },
  { id: "bil8", structureId: "str1", month: "2026-02", pharmacyId: "ph1", specialistId: "doc1", serviceId: "emocromo", count: 6, unitFee: 12, total: 72 },
  { id: "bil9", structureId: "str1", month: "2026-02", pharmacyId: "ph2", specialistId: "doc2", serviceId: "ecg", count: 4, unitFee: 18, total: 72 },
  { id: "bil10", structureId: "str1", month: "2026-02", pharmacyId: "ph2", specialistId: "doc1", serviceId: "colesterolo", count: 5, unitFee: 9, total: 45 }
];

// ============ CITIZEN: PHARMACY ASSOCIATIONS & CONSENTS ============
export const patientPharmacyAssociations = [
  { patientId: "1", pharmacyId: "ph1", isPreferred: true, associatedAt: "2024-03-15" },
  { patientId: "1", pharmacyId: "ph2", isPreferred: false, associatedAt: "2025-01-10" },
  { patientId: "1", pharmacyId: "ph3", isPreferred: false, associatedAt: "2025-09-22" }
];

export const patientConsentsData = [
  {
    patientId: "1",
    fse: { active: true, scope: "full", updatedAt: "2025-12-01" },
    marketing: { email: true, sms: false, push: true, updatedAt: "2025-11-20" },
    research: { active: false, anonymized: true, updatedAt: "2025-06-10" },
    caregiver: { enabled: true, name: "Anna Verdi", relationship: "Coniuge", phone: "+39 333 9988776", email: "anna.verdi@email.it", scope: "view_only" },
    dataSharing: { regional: true, european: false, updatedAt: "2025-12-01" }
  }
];

export const helperGetPatientConsents = (patientId) =>
  patientConsentsData.find(c => c.patientId === patientId);

// ============ CITIZEN: PATIENT-VISIBLE BOOKINGS HELPERS ============
export const getActivePatientBookings = (patientId) =>
  bookingsData.filter(b => b.patientId === patientId && ["confirmed", "pending", "rescheduled"].includes(b.status));

export const computeReportingMs = (received, delivered) => {
  if (!delivered) return null;
  return new Date(delivered).getTime() - new Date(received).getTime();
};
